<template>
  <div id="app">
    <div id="certify">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-if='data.datas.length>0' v-for='(item,index) in data.datas' :key='index'>
            <div class="result">
              <div class="banner">
                <img :src="data.imgUrl" alt="">
                <h1>{{data.typeName}}</h1>
                <div class="pWrap">
                  <p v-for='i in item.otherInfoMap'>
                    <span style="opacity:0.5;">{{i.key}}：</span>
                    <span>{{i.value}}</span>
                  </p>
                </div>

              </div>
              <div class="code" >
                <img :src="item.qrCodeBase64" alt="">
              </div>
              <p class='refresh' @click='reFresh'>
                <img src="//s.quanmin110.com/s/web/vue/img/refresh.png" alt="">
                每10秒自动刷新二维码
              </p>
              <div v-if='data.type=="sydwfrzs"||data.type=="ejjzszyzgzs"||data.type=="sfz"||data.type=="bdcqzs"||data.type=="bdcdjzm"' class="preBtn" @click='toInfo(item.code)'>
                <img src="../assets/icon_file@3x.png" alt="">
                证照详情
              </div>
            </div>

          </div>

          <div class="swiper-slide" v-if='data.datas.length==0'>
            <div class="result result_empty">
              <div class="banner">
                <img :src="data.imgUrl" alt="">
                <h1>{{data.typeName}}</h1>
              </div>
              <div class="code" >
                <img class="empty" src="../assets/empty.png" alt="">
                <p>暂未获取到您的证照信息</p>
              </div>
            </div>
          </div>

        </div>

        <div v-if='data.datas.length>1' class="swiper-pagination"></div>
        <div v-if='data.datas.length>1' class="look_all" @click='allFun'>
          查看全部
        </div>
      </div>

    </div>

  </div>
</template>

<script>
let qrcode = '';
let times=null;
let mySwiper;
import store from '../store.js'
import { MessageBox,Toast,Indicator } from 'mint-ui'
import QRCode from 'qrcodejs2';
import ew_code from '../assets/111.png'
export default {
  name: 'App',
  data () {
    return {
      code: [],
      token:'',
      cerType:'',
      ticket:'',
      data:{
        //datas:[]
      },
      data1:{},
      name:'',
      idCard:''
    }
  },
  mounted (){
    let that =this;
    //this.swipeFun();
  },
  created(){
    let that =this;
    // that.data = that.data3;
    // that.$nextTick(function(){
    //   that.swipeFun();
    // });
    let code = location.href.split('code=')[1];
  	if(code){
  	    this.ticket=code;
        this.getCode();
  	}else{
  		this.getTicket()
  	}

  },
  methods:{
    allFun(){
      store.commit('listFun',this.data);
      this.$router.push({
        name:'all'
      })
    },
    swipeFun(){
      mySwiper = new Swiper(".swiper-container", {
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
      	slidesPerView: "auto",
      	centeredSlides: true,
      	watchSlidesProgress: true,
      	pagination : '.swiper-pagination',
      	paginationClickable: false,
      	onProgress: function(a,b) {
      		var b, c, d, scale, es;
      		for(b = 0; b < a.slides.length; b++) c = a.slides[b], d = c.progress, scale = 1 - Math.min(Math.abs(.2 * d), 1), es = c.style, es.opacity = 1 - Math.min(Math.abs(d / 2), 1), es.webkitTransform = es.MsTransform = es.msTransform = es.MozTransform = es.OTransform = es.transform = "translate3d(0px,0," + -Math.abs(150 * d) + "px)"
      	}
      });
      if(sessionStorage.swiper_index){
        mySwiper.slideTo(sessionStorage.swiper_index);
      }
    },
    getTicket(){
      let that =this;
      lightAppJssdk.user.getTicket({
       success: function(data) { //成功回调
        if(data == '未登录') {
         //调登录
         that.login();
        } else {
         var jsonData = JSON.parse(data);
         if(jsonData.retcode == "000000") {
          jsonData = JSON.parse(jsonData.data);
          that.ticket = jsonData.ticket;
          console.log(jsonData.ticket);
          that.getCode();
         }
        }
       },
       fail: function(data) {
        //错误返回
        Toast({
          message: data,
          position: 'bottom',
          duration: 1000
        });
       }
      });
    },
    login(){
      lightAppJssdk.user.loginapp({
        success: function(data) {
         var dataObj = JSON.parse(data);
         if(dataObj.retcode == '000000') { //登录成功
          var dataValueObj = JSON.parse(dataObj.data);
          that.ticket = dataValueObj.ticket;
          that.getCode();
         } else {
          //失败
          Toast({
            message: '请稍后再试',
            position: 'bottom',
            duration: 1000
          });
         }
        },
        fail: function(data) {
         //登录失败
         Toast({
           message: data,
           position: 'bottom',
           duration: 1000
         });
        }
       });
    },
    toInfo (e){
      Indicator.open('副本生成中...');
      let that = this;
      this.$axios({
        method: 'get',
        url: '/user/certs/info/getStr?token='+that.token+'&code='+e,

      }).then(function (res) {
        Indicator.close();
        sessionStorage.token=that.token;
        sessionStorage.code=e;
        sessionStorage.index=0;
        if(res.data.error==0){
          clearInterval(times);
          store.commit('formFun',res.data.data);
          that.$router.push({
            name:'info'
          })
        }else {
          Toast({
            message: res.data.message,
            position: 'bottom',
            duration: 1000
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    },
    getCode(){
      let that = this;
      Indicator.open();
      this.$axios({
        method: 'POST',
        url: '/user/certs/info/'+that.$route.query.cerType,
        timeout:35000,
        headers:{
          ticket:that.ticket
          // ticket:123
        }
      }).then(function (res) {
        Indicator.close();
        if(res.data.error==0){
          that.data = res.data.data;
          that.data1 = res.data.data;
          that.$nextTick(function(){
            that.swipeFun();
          });
          that.token = res.data.data.token;
          if(that.data.datas.length>0){
            // setTimeout(function(){
              that.timeFn();
            // },10000);
          }

        }else {
          Toast({
            message: res.data.message,
            position: 'bottom',
            duration: 1000
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    reFresh(){
      clearInterval(times);
      this.timeFn();
    },
    timeFn(){
      let that =this;
      that.getInfo();
      times = setInterval(function(){
        that.getInfo();
			},10000)
    },
    getInfo(){
      // for(var i=0;i<2;i++){
      //   this.data1.datas[i].realName ='123';
      //   this.data1.datas[i].qrCodeBase64='//s.quanmin110.com/s/web/vue/img/refresh.png';
      // }
      // this.data = this.data1;
      Indicator.open();
      let that = this;
      this.$axios({
        method: 'get',
        url: '/user/certs/info/refresh?token='+that.token,
      }).then(function (res) {
        Indicator.close();
        if(res.data.error==0){
          for(var i=0;i<res.data.data.length;i++){
            that.data1.datas[i].code=res.data.data[i].code;
            that.data1.datas[i].qrcode=res.data.data[i].qrcode;
            that.data1.datas[i].qrCodeBase64=res.data.data[i].qrCodeBase64;
            that.data1.datas[i].qrcodeType=res.data.data[i].qrcodeType;
            that.data1.datas[i].qrCodeVaildDate=res.data.data[i].qrCodeVaildDate;
          }
          that.data = that.data1;
        }else {
          // Toast({
          //   message: res.data.message,
          //   position: 'bottom',
          //   duration: 1000
          // });
        }

      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style lang='scss' scoped="">

#certify {
	position: relative;
	width: 100%;
	margin: 0 auto
}
#certify .swiper-container {
  width: 100%;
	-webkit-perspective: 1200px;
	-moz-perspective: 1200px;
	-ms-perspective: 1200px;
	perspective: 1200px;
  // height: 600px;
}
#certify  .swiper-slide {
	width: 95%;
  -webkit-transform-style: preserve-3d;
	-moz-transform-style: preserve-3d;
	-ms-transform-style: preserve-3d;
	transform-style: preserve-3d;
  // box-shadow: 0 8px 30px #ddd;

}
.swiper-pagination {
  // top: 500px;
  bottom: 40px;
}

  .result {
    margin: 0 18px;
    background: #fff;
    padding-bottom: 10px;
    border-radius: 10px;
  }
  .result.result_empty {
    padding-bottom: 70px;
    text-align: center;

    img.empty {
      width: 70%;
      margin-top: 40px;
    }
    p {
      text-align: center;
      color: #333;
    }
  }
  .banner {
    position: relative;
    color: #fff;
    text-align: left;
    img {
      width: 100%;
    }
    h1 {
      font-size: 20px;
      position: absolute;
      top: 8px;
      left:20px;
      width: 218px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .pWrap {
      color: #fff;
      position: absolute;
      top: 83px;
      left: 20px;
      font-size: 13px;
      p{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        padding: 1px 0;
        padding-right: 20px;
        margin: 0;
        text-shadow:0 1px 2px rgba(0,0,0,0.1);
      }
    }
    h2 {
      font-size: 15px;
      position: absolute;
      bottom: 10px;
      width: 100%;
    }
    span.fl {
      margin-left: 20px;
    }
    span.fr {
      margin-right: 40px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
  }
  .code {
    width: 200px;
    margin: 15px auto;
    margin-bottom: 0px;
    display: block;
    img {
      width: 100%;
    }
  }

  .refresh {
    padding: 0;
    margin: 0;
    font-size: 14px;
    text-align: center;
    img {
      width: 45px;
      vertical-align: -webkit-baseline-middle;
      margin-right: -10px;
      margin-top:2px;
      margin-left: -24px;
    }
  }
  .preBtn {
    background: #2F7BEC;
    width:max-content;
    margin: 10px auto;
    color: #fff;
    border-radius: 50px;
    padding: 10px 20px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 2px;
    img {
      vertical-align: sub;
      width: 15px;
    }
  }

  .qrcode {
    width: 100%;
    height: 250px;
       //display: none;
  }
  .look_all {
    text-align: center;
    margin-top: 20px;
    font-size: 16px;
    color: #2F7BEC;
    // position: absolute;
    width: 100%;
    margin-top: 60px;
    // bottom: 0;
    z-index: 10;
  }

</style>



// WEBPACK FOOTER //
// src/pages/index/components/index.vue